<template>
  <svg viewBox="0 0 24 24" fill="#000000" xmlns="http://www.w3.org/2000/svg" version="1.1"><g id="SVGRepo_bgCarrier" stroke-width="0" />
      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
      <g id="SVGRepo_iconCarrier">
        <g fill="none" fill-rule="evenodd">
          <circle cx="7" cy="12" r="7" fill="#ffffff" />
          <circle cx="17" cy="12" r="7" fill="#ffffff" fill-opacity=".8" />
        </g>
      </g>
    </svg>
</template>

<script>
export default {
  name: 'card_list_mastercard',
}
</script>
